import { render, staticRenderFns } from "./CropperImage.vue?vue&type=template&id=1265fd3a&scoped=true"
import script from "./CropperImage.vue?vue&type=script&lang=js"
export * from "./CropperImage.vue?vue&type=script&lang=js"
import style0 from "./CropperImage.vue?vue&type=style&index=0&id=1265fd3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1265fd3a",
  null
  
)

export default component.exports